/**
 * TreeJS is a JavaScript librarie for displaying TreeViews
 * on the web.
 *
 * @author Matthias Thalmann
 */

const TreeUtil = {
    default_leaf_icon: '<span>&#128441;</span>',
    default_parent_icon: '<span>&#128449;</span>',
    default_open_icon: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" style="cursor: pointer" viewBox="0 0 20 20" fill="none">\n' +
        '<rect y="3.05176e-05" width="20" height="20" rx="10" fill="var(--icon-accordion)"/>\n' +
        '<path d="M13.1694 10H9.99998H6.83057" stroke="var(--icon-primary)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n' +
        '</svg>',
    default_close_icon: '<svg width="20" height="20" style="cursor: pointer" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '<rect y="3.05176e-05" width="20" height="20" rx="10" fill="var(--icon-accordion)"/>\n' +
        '<path d="M10.0712 13.9775V10M10.0712 6.02254V10M10.0712 10H14.0487M10.0712 10H6.09375" stroke="var(--icon-primary)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n' +
        '</svg>',
    default_loading_icon: '<svg class="structure-animate" width="20" height="20" style="cursor: pointer" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 25 25" fill="none">\n' +
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25ZM12.5 22C17.7467 22 22 17.7467 22 12.5C22 7.25329 17.7467 3 12.5 3C7.25329 3 3 7.25329 3 12.5C3 17.7467 7.25329 22 12.5 22Z" fill="currentcolor"/>\n' +
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M16.9667 20.8865C15.6352 21.5972 14.1147 22 12.5 22C7.25329 22 3 17.7467 3 12.5C3 7.25329 7.25329 3 12.5 3C14.2299 3 15.8519 3.46239 17.2489 4.27032L18.7492 1.67181C16.9108 0.608534 14.7765 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25C14.5714 25 16.5251 24.4962 18.2453 23.6044L16.9667 20.8865Z" fill="var(--link-primary)"/>\n' +
        '</svg>',
    expandNode: function (node) {
        node.setExpanded(true);

        if (!node.isLeaf()) {
            node.getChildren().forEach(function (child) {
                TreeUtil.expandNode(child);
            });
        }
    },

    collapseNode: function (node) {
        node.setExpanded(false);

        if (!node.isLeaf()) {
            node.getChildren().forEach(function (child) {
                TreeUtil.collapseNode(child);
            });
        }
    },

    getSelectedNodesForNode: function (node) {
        if (!(node instanceof TreeNode)) {
            throw new Error('Parameter 1 must be of type TreeNode');
        }

        var ret = new Array();

        if (node.isSelected()) {
            ret.push(node);
        }

        node.getChildren().forEach(function (child) {
            if (child.isSelected()) {
                if (ret.indexOf(child) == -1) {
                    ret.push(child);
                }
            }

            if (!child.isLeaf()) {
                TreeUtil.getSelectedNodesForNode(child).forEach(function (_node) {
                    if (ret.indexOf(_node) == -1) {
                        ret.push(_node);
                    }
                });
            }
        });

        return ret;
    }
};

const TreeConfig = {
    leaf_icon: TreeUtil.default_leaf_icon,
    parent_icon: TreeUtil.default_parent_icon,
    open_icon: TreeUtil.default_open_icon,
    close_icon: TreeUtil.default_close_icon,
    open_loading: TreeUtil.default_loading_icon,
    context_menu: undefined
};

class TreeView {
    constructor(rootId, root, container, options = {}) {
        if (typeof root === 'undefined') {
            throw new Error('Parameter 1 must be set (root)');
        }

        if (!(root instanceof TreeNode)) {
            throw new Error('Parameter 1 must be of type TreeNode');
        }

        this.state = {};
        this.root = root;
        this.rootId = rootId;
        this.container = container;
        this.options = options;
        this.reload();
    }

    expandAllNodes() {
        this.root.setExpanded(true);
        this.root.getChildren().forEach(TreeUtil.expandNode);
    }


    expandPath(path) {
        if (!(path instanceof TreePath)) {
            throw new Error('Parameter 1 must be of type TreePath');
        }

        path.getPath().forEach(node => {
            node.setExpanded(true);
        });
    }

    collapseAllNodes() {
        this.root.setExpanded(false);

        this.root.getChildren().forEach(TreeUtil.collapseNode);
    }

    getSelectedNodes() {
        return TreeUtil.getSelectedNodesForNode(this.root);
    }

    reload() {
        if (!(this.container instanceof Node)) {
            console.warn('No container specified');
            return;
        }

        this.container.classList.add('tj_container');

        const cnt = document.createElement('ul');
        cnt.appendChild(this.renderNode(this.root));

        this.container.innerHTML = '';
        this.container.appendChild(cnt);
    }


    renderNode(node) {
        var activeClasse = '';
        if (node.data.active) {
            activeClasse = 'structure-active';
        }
        const li_outer = document.createElement('li');
        const span_desc = document.createElement('span');
        span_desc.className = 'tj_description ' + activeClasse;
        span_desc.tj_node = node;

        li_outer.setAttribute('data-tag-id', node.data._id);
        li_outer.classList.add('tj_container_li');

        if (!node.isEnabled()) {
            li_outer.setAttribute('disabled', '');
            node.setExpanded(false);
            node.setSelected(false);
        }

        if (node.isSelected()) {
            span_desc.classList.add('selected');
        }

        span_desc.addEventListener('click', e => {
            if (!e.target.hasAttribute('attr-link')) {
                e.stopImmediatePropagation();
                node.onClick(e, this);
            }
        });

        span_desc.addEventListener('contextmenu', function (e) {
            var cur_el = e.target;

            while (typeof cur_el.tj_node === 'undefined' || cur_el.classList.contains('tj_container')) {
                cur_el = cur_el.parentElement;
            }

            var node_cur = cur_el.tj_node;

            if (typeof node_cur === 'undefined') {
                return;
            }

            if (typeof node_cur.getListener('contextmenu') !== 'undefined') {
                node_cur.on('contextmenu')(e, node_cur);
                e.preventDefault();
            }
            else if (typeof TreeConfig.context_menu === 'function') {
                TreeConfig.context_menu(e, node_cur);
                e.preventDefault();
            }
        });

        span_desc.innerHTML = node.render();
        span_desc.classList.add('tj_leaf');

        if (node.isLeaf() && !node.data.has_child) {
            span_desc.classList.add('no_child');
        }

        li_outer.appendChild(span_desc);

        if (node.isExpanded()) {
            var ul_container = document.createElement('ul');

            node.getChildren().forEach(child => {
                ul_container.appendChild(this.renderNode(child));
            });

            li_outer.appendChild(ul_container);
        }


        return li_outer;
    }
}

class TreeNode {

    constructor(settings = {}) {
        this.events = [];

        this.data = {
            _id: settings._id || settings.hash || '-1',
            keyword: settings.title || 'missing label',
            children: [],
            url: settings.url || false,
            has_child: settings.hasChild || false,
            active: settings.active || false,
            parent_id: settings._id || null,
            parent: settings.parent || null,
            icon: settings.iconPath || '',
            leaf_icon: settings.leaf_icon || TreeUtil.default_leaf_icon,
            parent_icon: settings.parent_icon || TreeUtil.parent_icon
        };


        this.state = {
            /** @var {boolean} allowChildren*/
            allowChildren: typeof settings.allowChildren !== 'undefined' ? settings.allowChildren : true,

            /** @var {boolean} expanded*/
            expanded: typeof settings.expanded !== 'undefined' ? settings.expanded : true,

            /** @var {boolean} enabled*/
            enabled: typeof settings.enabled !== 'undefined' ? settings.enabled : true,

            /** @var {boolean} selected*/
            selected: typeof settings.selected !== 'undefined' ? settings.selected : false
        };


        this.onSetup(settings);
        this.generateChildren(settings);
    }

    render() {
        var ret = '';
        var icon = this.data.icon;

        if (this.isLeaf()) {
            if (icon != '') {
                ret += '<span class="tj_icon">aaa' + icon + '</span>';
            }
            else if ((icon = this.data.leaf_icon) != '') {
                ret += `<span class="tj_icon">${icon}</span>`;
            }
            else {
                ret += `<span class="tj_icon">${TreeConfig.leaf_icon}</span>`;
            }
        }

        else {

            if (this.isExpanded()) {
                ret += '<span class="tj_mod_icon">' + TreeConfig.open_icon + '</span>';
            }
            else {
                ret += '<span class="tj_mod_icon">' + TreeConfig.close_icon + '</span>';
            }

            var icon = this.data.icon;
            if (
                icon != '' ||
                (icon = (this.data.parent_icon || '')) !== ''
            ) {
                ret += `<span class="tj_icon">${icon}</span>`;
            }

            else {
                ret += `<span class="tj_icon">${TreeConfig.parent_icon}</span>`;
            }

        }

        return ret + `${this.data.keyword} </span>`;
    }

    onClick(e, tree) {
        if (this.isEnabled()) {
            if (e.ctrlKey === false) {
                if (!this.isLeaf()) {
                    this.toggleExpanded();
                    tree.reload();
                }

                else {
                    this.open();
                }

                // node_cur.on("click")(e, node_cur);
            }


            if (e.ctrlKey === true) {
                this.toggleSelected();
                tree.reload();
            }
            else {
                var rt = this.getRoot();

                if (rt instanceof TreeNode) {
                    TreeUtil.getSelectedNodesForNode(rt).forEach(function (_nd) {
                        _nd.setSelected(false);
                    });
                }

                this.setSelected(true);

                tree.reload();
            }
        }
    }

    onSetup(settings = {}) {
        // override me !
    }

    generateChildren(settings = {}) {
        if (
            Array.isArray(settings.children) &&
            settings.children.length > 0
        ) {
            settings.children.forEach(child => {
                this.addChild(child);
            });

            this.state.childrenAreLoaded = true;
        }
    }


    createChild(nodeData) {
        return new TreeNode(nodeData);
    }

    addChild(nodeData) {
        const node = this.createChild(nodeData);
        if (this.state.allowChildren !== true) {
            console.warn('Option allowsChildren is set to false, no child added');
            return;
        }

        if (node instanceof TreeNode) {
            this.data.children.push(node);

            node.data.parent = this;
        }

        else {
            throw new Error('Parameter 1 must be of type TreeNode');
        }
    }

    removeChildPos(pos) {
        const children = this.data.children;
        if (typeof children[pos] !== 'undefined') {
            if (typeof children[pos] !== 'undefined') {
                const child = children.splice(pos, 1);
                child.parent = null;
            }
        }
    }

    removeChild(node) {
        if (!(node instanceof TreeNode)) {
            throw new Error('Parameter 1 must be of type TreeNode');
        }

        this.removeChildPos(this.getIndexOfChild(node));
    }

    getChildren() {
        return this.data.children;
    }

    getChildCount() {
        return this.data.children.length;
    }

    getIndexOfChild(node) {
        const children = this.data.children;
        for (let i = 0; i < children.length; i++) {
            if (children[i].equals(node)) {
                return i;
            }
        }

        return -1;
    }

    getRoot() {
        let node = this;

        while (
            node.data.parent instanceof TreeNode
            ) {
            node = node.data.parent;
        }

        return node;
    }


    isLeaf() {
        return this.data.children.length === 0;
    }

    isSelected() {
        return this.state.selected === true;
    }

    /**
     *
     * @param {boolean} _expanded
     */
    setExpanded(_expanded) {
        if (this.isLeaf()) {
            return;
        }

        if (typeof _expanded === 'boolean') {
            if (this.state.expanded === _expanded) {
                return;
            }

            this.state.expanded = _expanded;

            if (_expanded) {
                this.on('expand')(this);
            }
            else {
                this.on('collapse')(this);
            }

            this.on('toggle_expanded')(this);
        }
    }

    toggleExpanded() {
        this.setExpanded(!this.state.expanded);
    }

    isExpanded() {
        return this.isLeaf() || this.state.expanded;
    }

    /**
     *
     * @param {boolean} _enabled
     */
    setEnabled(_enabled) {
        if (typeof _enabled === 'boolean') {
            if (this.state.enabled === _enabled) {
                return;
            }

            this.state.enabled = _enabled;

            if (_enabled) {
                this.on('enable')(this);
            }

            else {
                this.on('disable')(this);
            }

            this.on('toggle_enabled')(this);
        }
    }

    toggleEnabled() {
        this.setEnabled(
            !(this.state.enabled === true)
        );
    }

    /**
     *
     * @return {boolean}
     */
    isEnabled() {
        return this.state.enabled;
    }

    /**
     *
     * @param {boolean} _selected
     */
    setSelected(_selected) {
        if (typeof _selected !== 'boolean') {
            return;
        }

        if (this.state.selected === _selected) {
            return;
        }

        this.selected = _selected;

        if (_selected) {
            this.on('select')(this);
        }

        else {
            this.on('deselect')(this);
        }

        this.on('toggle_selected')(this);
    }

    toggleSelected() {
        this.setSelected(!(this.selected === true));
    }

    open() {
        if (!this.isLeaf()) {
            this.on('open')(this);
        }
    }

    on(ev, callback) {
        if (typeof callback === 'undefined') {
            if (typeof this.events[ev] !== 'function') {
                return function () {
                };
            }
            else {
                return this.events[ev];
            }
        }

        if (typeof callback !== 'function') {
            throw new Error('Argument 2 must be of type function');
        }

        this.events[ev] = callback;
    }

    getListener(ev) {
        return this.events[ev];
    }

    equals(node) {
        if (node instanceof TreeNode) {
            if (node.data._id === this.data._id) {
                return true;
            }
        }

        return false;
    }

    toString() {
        return this.data._id;
    }
}

class LazyTreeView extends TreeView {
    constructor(settings = {}) {
        super(
            settings.rootId,
            settings.rootNode,
            settings.container,
            settings.options
        );

        this.data = {
            endpoints: {
                getChildren: settings.endpoints.getChildren
            }
        };

        this.state.rootPathIsLoaded = false;
        this.state.childrenAreLoaded = false;
    }

    isLeaf() {
        return (
            this.data.children.length === 0 &&
            this.state.childrenAreLoaded === true
        );
    }

    static async generate(settings = {}) {
        const rootTree = settings.rootTree;
        const endpoints = settings.endpoints;

        // call a ws in order to get a structured json containing tags from root to a specific tag_id
        // const partialTreeFromRootToTag = (await imaios.getJSON(`${endpoints.getRootPath}\\${rootId}`));

        const rootNode = new LazyTreeNode({
            endpoints,
            ...rootTree
        });

        const tree = new LazyTreeView({
            rootNode,
            ...settings
        });
    }
}

class LazyTreeNode extends TreeNode {
    constructor(settings = {}) {
        super(settings);
    }

    onSetup(settings = {}) {
        super.onSetup(settings);

        this.data.endpoints = {
            getChildren: settings.endpoints.getChildren
        };

        this.state.rootPathIsLoaded = settings.rootPathIsLoaded || false;
        this.state.childrenAreLoaded = false;
    }

    createChild(nodeData) {
        return new LazyTreeNode({
            endpoints: this.data.endpoints,
            rootPathIsLoaded: this.state.rootPathIsLoaded,
            ...nodeData
        });
    }

    render() {
        var ret = '';
        var icon = this.data.icon;
        var hasChild = this.data.has_child;

        if (this.isLeaf()) {
            if (!this.isExpanded() && hasChild) {
                ret += '<span class="tj_mod_icon">' + TreeConfig.open_icon + '</span>'; //(open = "+")
            }
            else if (hasChild) {
                ret += '<span class="tj_mod_icon">' + TreeConfig.close_icon + '</span>'; //(close = "-")
            }

            if (icon != '') {
                ret += '<span class="tj_icon">' +
                    '<img src="' + icon + '"/></span>';
            }
            else if ((icon = this.data.leaf_icon) != '') {
                ret += `<span class="tj_icon"><img src="${icon}"/></span>`;
            }
            else {
                ret += `<span class="tj_icon">${TreeConfig.leaf_icon}</span>`;
            }
        }
        else {
            if (this.isExpanded()) {
                ret += '<span class="tj_mod_icon">' + TreeConfig.open_icon + '</span>';
            }
            else {
                ret += '<span class="tj_mod_icon">' + TreeConfig.close_icon + '</span>';
            }

            var icon = this.data.icon;
            if (
                icon != '' ||
                (icon = (this.data.parent_icon || '')) !== ''
            ) {
                ret += `<span class="tj_icon"><img src="${icon}"/></span>`;
            }
            else {
                ret += `<span class="tj_icon">${TreeConfig.parent_icon}</span>`;
            }
        }

        const ta = getTA(this.data.endpoints.getChildren);
        if (ta !== null && !/\#from=\d/.test(this.data.url)) {
            this.data.url += '#from=' + ta;
        }
        return ret + '</span>' + '<a attr-link href="' + this.data.url + '">' + this.data.keyword + '</a>';
    }

    async loadChildren() {
        var id = this.data._id;
        var descriptionElement = document.querySelector('li[data-tag-id="' + id + '"] .tj_description');
        var iconElement = document.querySelector('li[data-tag-id="' + id + '"] .tj_description .tj_mod_icon');
        if (!iconElement) {
            return;
        }

        iconElement.classList.add('d-none');
        const spanLoading = document.createElement('span');
        spanLoading.classList.add('tj_mod_icon');
        spanLoading.classList.add('structure-animate');
        spanLoading.innerHTML = TreeConfig.open_loading;
        descriptionElement.prepend(spanLoading);

        const childrenData = await imaios.getJSON(this.data.endpoints.getChildren + '/' + this.data._id);

        if (Array.isArray(childrenData)) {
            [ ...this.data.children ].forEach(child => {
                this.removeChild(child);
            });

            childrenData.forEach(data => {
                this.addChild(data);
            });
        }

        this.state.childrenAreLoaded = true;
    }

    onClick(e, tree) {
        // console.log(e.target); check the target to know if you are cliking on href or button dropdown tree ?
        if (this.isEnabled()) {
            if (e.ctrlKey === false) {
                if (this.state.childrenAreLoaded !== true) {
                    this.loadChildren().then(() => {
                        tree.reload();
                    });
                }

                else {
                    this.toggleExpanded();
                    tree.reload();
                }
            }
        }
    }

}

class TreePath {
    constructor(root, node) {
        this.nodes = [];

        if (
            root instanceof TreeNode &&
            node instanceof TreeNode
        ) {
            this.setPath(root, node);
        }
    }

    setPath(root, node) {
        this.nodes = [];

        while (typeof node !== 'undefined' && !node.equals(root)) {
            this.nodes.push(node);
            node = node.parent;
        }

        if (node.equals(root)) {
            this.nodes.push(root);
        }

        else {
            this.nodes = [];
            throw new Error('Node is not contained in the tree of root');
        }

        this.nodes = this.nodes.reverse();

        return this.nodes;
    }

    getPath() {
        return this.nodes;
    }

    toString() {
        return this.nodes.join(' - ');
    }
}

function getTA(url) {
    const splittedUrl = url.split('/');
    if (Array.isArray(splittedUrl)) {
        const number = splittedUrl[splittedUrl.length - 1];
        return number;
    }
    return null;
}

export {
    TreeView,
    TreeNode,
    TreeUtil,
    TreePath,
    LazyTreeView,
    TreeConfig
};
